import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTrending6"><Path d="M16.5 17.5H21.5V12.5M20.9722 16.95L13 9L9 13L2.5 6.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTrending6;
